"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const tabs_1 = __importDefault(require("../../tabs/tabs"));
const historyBoxConstants_1 = require("../historyBoxConstants");
const callHistoryTable_1 = __importDefault(require("./callHistoryTable"));
const noteHistoryTable_1 = __importDefault(require("./noteHistoryTable"));
const remindersHistoryTable_1 = __importDefault(require("./remindersHistoryTable"));
const ivrActionHistoryTable_1 = __importDefault(require("./ivrActionHistoryTable"));
const ActionHistoryTable = ({ historyActions }) => {
    const [selectedTab, setSelectedTab] = react_1.useState('call');
    const tabs = [
        { key: 'call', name: historyBoxConstants_1.CALL },
        { key: 'note', name: historyBoxConstants_1.NOTES },
        { key: 'reminder', name: historyBoxConstants_1.REMINDERS },
        { key: 'ivr_actions', name: historyBoxConstants_1.IVR_ACTIONS },
    ];
    const getData = (key) => historyActions.filter((loanHistoryAction) => loanHistoryAction.action_type === key);
    const callHistoryTable = react_1.default.createElement(callHistoryTable_1.default, { callHistoryActions: getData('call') });
    const noteHistoryTable = react_1.default.createElement(noteHistoryTable_1.default, { noteHistoryActions: getData('note') });
    const remindersHistoryTable = react_1.default.createElement(remindersHistoryTable_1.default, { remindersHistoryActions: getData('reminder') });
    const ivrActionsHistoryTable = react_1.default.createElement(ivrActionHistoryTable_1.default, { ivrActionsHistoryActions: getData('ivr_actions') });
    const allHistoryTables = new Map([
        ['call', callHistoryTable],
        ['note', noteHistoryTable],
        ['reminder', remindersHistoryTable],
        ['ivr_actions', ivrActionsHistoryTable],
    ]);
    return (react_1.default.createElement(react_native_1.View, null,
        react_1.default.createElement(react_native_1.View, { style: { marginVertical: 20 } },
            react_1.default.createElement(tabs_1.default, { selectedTab: selectedTab, setSelectedTab: setSelectedTab, tabs: tabs })),
        allHistoryTables.get(selectedTab)));
};
exports.default = ActionHistoryTable;
